export default __webpack_public_path__ + "paddle_farming6dabc9.svg";